/* Giftship occasion bridge.
   Reads the resolved door from the .mday2026-product wrapper's data-occasion
   attribute and mirrors it into a Giftship Hidden Input named _occasion, so
   option-set blocks can gate on the page's occasion (Block Conditions on
   _occasion). Sanctioned Hidden Input pattern per Giftship's docs: writes only
   to the Giftship-provided input via the official events, never mutates
   Giftship-rendered DOM. No-ops safely if the Hidden Input block is not
   configured in the Giftship dashboard yet. */
(function () {
  function applyOccasion() {
    try {
      var wrap = document.querySelector('.mday2026-product');
      var inputs = document.querySelectorAll('[data-child-name="_occasion"] input');
      if (!wrap || !inputs.length) return;
      var occ = wrap.dataset.occasion || 'brand';
      var changed = false;
      inputs.forEach(function (input) {
        if (input.value !== occ) { input.value = occ; changed = true; }
      });
      if (changed && typeof Gs === 'object' && Gs.productOptions && typeof Gs.productOptions.checkConditions === 'function') {
        Gs.productOptions.checkConditions();
      }
    } catch (e) {
      console.warn('giftship-occasion-bridge:', e);
    }
  }
  document.addEventListener('giftship.loaded', applyOccasion);
  document.addEventListener('giftship.reloaded', applyOccasion);
})();

/* Blanket personalization persistence + tidy view (_blanket_on flag).
   1) Mirrors the blanket upsell checkbox (inside _personalize_baby) into the
      Giftship Hidden Input _blanket_on so the personalization blocks stay
      ACTIVE in Giftship's rule engine while the customer browses other add-on
      categories (fix for baby names lost at add-to-cart).
   2) Sets data-gs-addon-view="blanket|other" on <body> from the add-on image
      gallery's current value, so theme CSS can collapse the blanket blocks
      while another category is open. Visual only: the engine keeps the blocks
      active (values still submit) because the display rules stay true via the
      flag. Writes only the hidden input's value and a theme-owned body
      attribute; never mutates Giftship-rendered DOM. */
(function () {
  function setView() {
    try {
      var gal = document.querySelector('#gsAppContainer [data-child-type="gallery"] input:checked');
      var v = gal ? String(gal.value || '') : '';
      document.body.setAttribute('data-gs-addon-view', /personalize/i.test(v) ? 'blanket' : 'other');
    } catch (e) { console.warn('giftship-blanket-view:', e); }
  }
  function applyBlanketFlag() {
    try {
      var flag = document.querySelector('[data-child-name="_blanket_on"] input');
      if (!flag) return;
      var section = document.querySelector('[data-child-name="_personalize_baby"]');
      var cb = section ? section.querySelector('input[type="checkbox"]') : null;
      var want = (cb && cb.checked) ? '1' : '';
      if (flag.value !== want) {
        flag.value = want;
        if (typeof Gs === 'object' && Gs.productOptions && typeof Gs.productOptions.checkConditions === 'function') {
          Gs.productOptions.checkConditions();
        }
      }
    } catch (e) { console.warn('giftship-blanket-flag:', e); }
  }
  function sync() { applyBlanketFlag(); setView(); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-child-name="_personalize_baby"]') || t.closest('[data-child-type="gallery"]')) sync();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-child-type="gallery"]')) setTimeout(sync, 50);
  });
  document.addEventListener('giftship.loaded', sync);
  document.addEventListener('giftship.reloaded', sync);
})();
